import { useLanguage } from '../../i18n/LanguageContext';
import { siteContent } from '../../data/siteContent';
import { PageHero, Surface } from '../../components/SitePrimitives';

const Me = () => {
    const { language } = useLanguage();
    const page = siteContent[language].pages.me;

    return (
        <main className="bg-nude-50">
            <PageHero image="/assets/brief/about.jpeg" title={page.title} />
            <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24">
                <Surface className="space-y-5 p-7 text-base leading-8 text-stone-600 sm:p-12">
                    {page.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                </Surface>
            </div>
        </main>
    );
};

export default Me;
